import axios from "./axios";

export async function searchProjectIndex({ projectId, query }) {
  return axios({
    method: "get",
    url: "/project_search",
    params: { project_id: projectId, query },
  }).then((response) => response.data);
}
